angular.module("tromanWeb").directive("ergoParseIntarray", [function () {

    var splitre = /\s*,\s*/;

    function notEmpty(s) {
        return s.length > 0;
    }

    function parseDec(s) {
        return parseInt(s, 10);
    }

    function parseArray(val) {
        if (!angular.isString(val))
            return undefined;

        var items = val.split(splitre);
        var nonempty = items.filter(notEmpty);
        var asnum = nonempty.map(parseDec);
        if (items.some(isNaN))
            return undefined;

        return asnum;
    }

    return {
        restrict: "A",
        require: "?ngModel",
        link: function (_scope, _element, _attributes, ngModelController) {
            if (!ngModelController) return;
            ngModelController.$parsers.push(parseArray);
        }
    };
}]);

angular.module("tromanWeb").directive("ergoInvert", [function () {

    function invert(val) {
        return !val;
    }

    return {
        restrict: 'A',
        require: '?ngModel',
        link: function (_scope, _element, _attr, ngModelCtrl) {
            if (!ngModelCtrl) return;
            ngModelCtrl.$parsers.push(invert);
            ngModelCtrl.$formatters.push(invert);
        }
    };
}]);